export enum SecureTransactionType {
  TRANSFER_BY_ACCOUNT = 'TRANSFER_BY_ACCOUNT',
  TRANSFER_BY_MY_ACCOUNT = 'TRANSFER_BY_MY_ACCOUNT',
  TRANSFER_TO_CUSTOMER_BY_LINE = 'TRANSFER_TO_CUSTOMER_BY_LINE',
  TRANSFER_TO_NON_CUSTOMER_BY_LINE = 'TRANSFER_TO_NON_CUSTOMER_BY_LINE',
  SCHEDULED_TRANSFER = 'SCHEDULED_TRANSFER',
  SCHEDULED_TRANSFER_VER2 = 'SCHEDULED_TRANSFER_VER2',
  BILL_PAYMENT_PAY_PULSA = 'BILL_PAYMENT_PAY_PULSA',
  BILL_PAYMENT_PAY_BILLS = 'BILL_PAYMENT_PAY_BILLS',
  BILL_PAYMENT_PAY_BETA = 'BILL_PAYMENT_VER2_PAY',
}
